<template>
  <svg
    class="base-timer__svg"
    viewBox="0 0 100 100"
  >
    <g class="base-timer__circle">
      <circle
        class="base-timer__path-elapsed"
        :class="statusClass"
        cx="50"
        cy="50"
        r="45"
      />
      <path
        class="base-timer__path-remaining"
        :class="statusClass"
        :stroke-dasharray="strokeValue"
        d="M 50, 50 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    lastMessage: {
      type: Object,
    },
  },
  data() {
    return {
      fullCircleCycleLength: 283,
      circleCycleDuration: 300,
      minOnlineSeconds: 150,
      minAwaySeconds: 300,
      currentTimeInterval: null,
      currentTime: null,
    };
  },
  computed: {
    elapsedTime() {
      if (this.lastMessage && this.lastMessage.createdAt) {
        return this.$moment(this.currentTime).diff(this.lastMessage.createdAt, 'seconds');
      }

      return 0;
    },
    statusClass() {
      return {
        online: this.elapsedTime <= this.minOnlineSeconds,
        away: this.elapsedTime > this.minOnlineSeconds && this.elapsedTime <= this.minAwaySeconds,
        offline: this.elapsedTime > this.minAwaySeconds,
      };
    },
    progressFraction() {
      return this.roundDecimals(
        (this.elapsedTime % this.circleCycleDuration) / this.circleCycleDuration,
      );
    },
    circleCycleProgress() {
      if (this.elapsedTime >= this.minAwaySeconds) {
        return this.fullCircleCycleLength;
      }

      return Math.floor(this.progressFraction * this.fullCircleCycleLength);
    },
    strokeValue() {
      return `${this.circleCycleProgress} ${this.fullCircleCycleLength}`;
    },
  },
  created() {
    this.currentTime = this.$moment();

    this.currentTimeInterval = setInterval(() => {
      this.currentTime = this.$moment();
    }, 200);
  },
  beforeDestroy() {
    clearInterval(this.currentTimeInterval);
  },
  methods: {
    roundDecimals(number) {
      return Math.round(number * 100) / 100;
    },
  },
};
</script>
